module.exports = __webpack_public_path__ + "img/logo11.1641ca7e.png";